import * as React from 'react';
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface TaskStatusViewProps {
    mode: ControlMode;
    label?: string;
    value: number | null;
	onChanged?: (number: number  | null ) => void;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	isNew?: boolean;
}

@observer
export class TaskStateEditorView extends React.Component<TaskStatusViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Task Status';
        }

		var options = [{ value: 0, displayName: 'New', disabled: false }];

		if (!this.props.isNew)
			options = [
				{ value: 0, displayName: 'New', disabled: true },
				{ value: 1, displayName: 'In Progress', disabled: false },
				{ value: 2, displayName: 'Finished', disabled: false },
				{ value: 4, displayName: 'Cancelled', disabled: false },
				{ value: 8, displayName: 'Out of date', disabled: true }
				]

        return (
            <DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				disableOption={item => item.value == 0 || item.value == 8}
				model={this.props.value}
				disabled={this.props.mode == 'display'}
				required={this.props.required}
				onChanged={(item) => {
					this.props.onChanged(item != null ? item.value : null);
				}}
				options={options}
				keyField='value'
				textField='displayName'
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/parts/task-state.editor.tsx